// extracted by mini-css-extract-plugin
export var pillTrigger = "_63-0";